const publicErrors = {
  BILLING_PAUSED_STATE_CHANGED: { key: "billing_paused_state_changed" },
  BILLING_PAUSED_PLAN_LOCKED: { key: "billing_paused_plan_locked" },
  BILLING_PAUSED_SETUP_IN_PROGRESS: { key: "billing_paused_setup_in_progress" },
  BILLING_PAUSED_DETAILS_REQUIRED: { key: "billing_paused_details_required" },
  BILLING_PAUSED_SETUP_REVIEW_REQUIRED: { key: "billing_paused_contact_support" },
  BILLING_DETAILS_MANAGED_IN_STRIPE: { key: "billing_details_managed_in_stripe" },
  BILLING_TRIAL_NOT_AVAILABLE: { key: "billing_trial_not_available" },
  BILLING_TRIAL_ENDING_SOON: { key: "billing_trial_ending_soon" },
  BILLING_CHECKOUT_NOT_OPEN: { key: "billing_state_checkout_not_open" },
  BILLING_IDENTITY_CHECKOUT_IN_PROGRESS: { key: "billing_identity_checkout_in_progress" },
};

// Only known, non-sensitive codes can select club-facing translation keys.
export const billingIdentityErrorPresentation = (
  codes,
  fallbackKey = "billing_setup_error"
) => {
  const known = (Array.isArray(codes) ? codes : [])
    .filter(
      (code) =>
        typeof code === "string" &&
        Object.prototype.hasOwnProperty.call(publicErrors, code)
    )
    .map((code) => publicErrors[code]);
  return {
    key: known[0]?.key || fallbackKey,
    fields: Object.fromEntries(
      known
        .filter((error) => error.field)
        .map((error) => [error.field, error.key])
    ),
  };
};
